module.exports = __webpack_public_path__ + "img/BulletTown.2bf15fea.png";